import { useCallback, useEffect, useState } from 'react'
import { useFetch } from '../../../utils/hooks/useFetch'
import { useTimesheetDetails } from './useTimesheetDetails';
import { translate } from '../../../utils/translations/translate';
import { getApproveRejectTimesheetServiceConfig } from '../../../utils/services/timesheet';
import { useNavigate } from 'react-router-dom';
import { SITE_LINKS_SCHEMA } from '../../../router/navlinks';
export const useTimesheetApproval = (timesheetId) => {
    const { isLoading: isPageBusy, performAction } = useFetch();
    const { isLoading: isFetchingTimesheet, selectedWeek, toastInfo, fetchTimesheetDetails, timesheetInfo, setToastInfo } = useTimesheetDetails();
    const [timesheetModelInfo, setTimesheetModelInfo] = useState(null);
    const [showApprovalModal, setShowApprovalModal] = useState(false);
    const [approvalModalInfo, setApprovalModalInfo] = useState(null);
    const navigate = useNavigate();
    const onApproveOrReject = (action) => {
        setShowApprovalModal(true);
        setApprovalModalInfo({
            ids: [timesheetId],
            action,
        })
    }
    const onCloseModal = useCallback(() => {
        setShowApprovalModal(false);
        setApprovalModalInfo(null);
    }, [])
    const approveOrRejectTimesheet = useCallback(async ({ ids, action, comments }) => {
        try {
            setShowApprovalModal(false);
            const { url, options } = getApproveRejectTimesheetServiceConfig(ids, action, comments);
            const response = await performAction(url, options);
            if (response?.StatusCode === 200) {
                setTimesheetModelInfo(info => {
                    return {
                        ...info,
                        status: action,
                        approverComments: comments,
                        showApproverActionButton:false
                    }
                })
                setTimeout(()=>{
                    navigate(SITE_LINKS_SCHEMA.TIME_SHEET_APPROVAL)
                },3000)
                return setToastInfo({
                    message: translate("labels.timsheetActionSuccessMsg"),
                    type: "success",
                    autoExpire: true
                })
            }
            throw new Error('Unable to perform action please try again');
        }
        catch (e) {
            console.error('Error updating the timesheet');
            setToastInfo({
                message: e.message,
                type: "error",
                autoExpire: true
            })
        }
        finally {
            window.scrollTo({ top: 0, behavior: "smooth" })
        }
    }, [performAction, setToastInfo,navigate])
    const handleToastClose = useCallback(()=>{
        setToastInfo(null);
    },[setToastInfo])
    useEffect(() => {
        fetchTimesheetDetails(timesheetId);
    }, [fetchTimesheetDetails, timesheetId])
    useEffect(() => {
        setTimesheetModelInfo(timesheetInfo);
    }, [timesheetInfo])
    return {
        isPageBusy: isPageBusy || isFetchingTimesheet,
        selectedWeek,
        toastInfo,
        timesheetInfo: timesheetModelInfo,
        approveOrRejectTimesheet,
        onApproveOrReject,
        onCloseModal,
        handleToastClose,
        showApprovalModal,
        approvalModalInfo
    }
}

